import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'parcel-notes-cell',
  imports: [CommonModule],
  template: `
    <mat-button
      *ngIf="isVisible"
      type="button"
      style="background-color: #2196F3; color: white;"
      class="btn btn-raised btn-primary notes-button"
      (click)="handleClick($event)"
    >
      {{ label }}
    </mat-button>
  `
})
export class ParcelNotesCellComponent {
  @Input() row!: any;

  @Input() canManageParcelNotes = false;
  @Input() canViewInternalParcelNotes = false;

  @Output() notesClick = new EventEmitter<any>();

  get isVisible(): boolean {
    const r = this.row;

    return !(
      (r.internalNote === '0' &&
        r.publicNote === '0' &&
        !r.canManageParcelNotes == true) ||
      (r.publicNote === '0' &&
        !r.canViewInternalParcelNotes == true)
    );
  }

  get label(): string {
    const r = this.row;

    if (
      r.internalNote === '0' &&
      r.publicNote === '0' &&
      r.canManageParcelNotes === true
    ) {
      return 'Add Note';
    }

    if (
      !(r.internalNote === '0' && r.publicNote === '0') &&
      r.canManageParcelNotes === true
    ) {
      return 'Modify Note';
    }

    if (
      !(r.internalNote === '0' && r.publicNote === '0') &&
      r.canManageParcelNotes !== true
    ) {
      return 'View Note';
    }

    return '';
  }

  handleClick(event: MouseEvent) {
    event.stopPropagation();
    this.notesClick.emit(this.row);
  }
}
